<template>
  <v-layout>
    <v-flex xs12 NewEditDeleteDialog>
      <v-dialog v-model="dialog" persistent :fullscreen="!$vuetify.breakpoint.md && !$vuetify.breakpoint.lg" max-width="1400">
        <v-card :loading="loading" v-if="!deleting">
          <v-card-title :class="`font-weight-bold`" style="font-size:22px;">
            <v-toolbar
              color="primary"
              dark
              absolute
              dense>
              <div>{{ resourceSettings.resourceName  + ' | ' }}
                <span class="font-weight-light">{{ newResource.id ? 'edit' : 'add' }}</span>
              </div>
              <v-spacer></v-spacer>
              <v-btn  flat @click.native="closeDialog()" >
                <v-icon class="hidden-md-and-up">close</v-icon>
                <span class="hidden-sm-and-down">cancel</span>
              </v-btn>
              <v-btn 
                v-if="!newResource.id"
                :disabled="!validate(newResource)"
                flat @click.native="postResource(newResource)" 
              >
                <v-icon class="hidden-md-and-up">save</v-icon>
                <span class="hidden-sm-and-down">save</span>
              </v-btn>
              <v-btn 
                  v-if="newResource.id"
                  :disabled="!validate(newResource)"
                  flat @click.native="updateResource(newResource)" 
                >
                <v-icon class="hidden-md-and-up">save</v-icon>
                <span class="hidden-sm-and-down">update</span>
              </v-btn>
            </v-toolbar>
          </v-card-title>
          <v-card-text class="mt-3">
            <v-layout row wrap>
              <v-flex xs12 my-2 v-for="(field, k) in resourceKeys.filter(field=>field.type != 'editor')" :key="'key-' + k">
                <v-text-field
                  :label="field.label"
                  :name="getNameID()"
                  :id="getNameID()"
                  
                  :readonly="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  :disabled="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  v-if="field.type == 'text' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  dense
                  box
                  v-model.trim="newResource[field.name]"
                >
                  <template slot="append">
                    <v-tooltip top>
                      <template slot="activator">
                        <v-icon size="18" color="primary">help</v-icon>
                      </template>
                      {{field.info.en}}
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" flat @click.native="closeDialog()" >cancel</v-btn>
            <v-btn 
              color="success" 
              v-if="!newResource.id && !loading" :loading="loading"
              :disabled="!validate(newResource)"
              flat @click.native="postResource(newResource)" 
              
            >submit</v-btn>
            <v-btn 
                color="success" :loading="loading"
                v-if="newResource.id && !loading"
                :disabled="!validate(newResource)"
                flat @click.native="updateResource(newResource)" 
                
              >update</v-btn>
          </v-card-actions>
        </v-card>
        <v-card :loading="loading" v-if="deleting">
          <v-card-title :class="`font-weight-bold`" style="font-size:22px;">
            <div>{{ resourceSettings.resourceName  + ' | ' }}<span class="font-weight-light">delete</span></div>
          </v-card-title>
          <v-card-text>
            <v-layout>
              <v-flex cols="12" md="12" class="pa-5 error white--text">
                {{ newResource.name }}
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" flat @click.native="closeDialog()" >cancel</v-btn>
            <v-btn 
                color="error" 
                v-if="newResource.id"
                flat @click.native="deleteResource(newResource)" 
                
              >delete</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-flex>
  </v-layout>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import pricesPanel from '@/components/pricesPanel'
import imagesPanel from '@/components/imagesPanel'
import axios from 'axios';
const headers = {'Accept': 'application/json'};

export default {
  components: {
    VueEditor, pricesPanel, imagesPanel
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings', 'resource'],
  data(){
    return {
      rules: {
        required: value => !!value || 'required',
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || 'valid_email'
      },
      datepicker:{},
      timepicker:{},
      menu:{},
    }
  },
  methods: {
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${x.name} required`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `Not valid email`, 'error')
        }
      })
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    setRTL() {
      this.$refs.editorV[0].quill.format('direction', 'rtl');
      this.$refs.editorV[0].quill.format('align', 'right');
    }
  },
  computed:{
    api(){
      return this.$store.state.settings.apiBase
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>